module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

	var SizePresets = {
	  xsmall: 8,
	  small: 16,
	  medium: 20,
	  large: 30,
	  xlarge: 48
	};

	function IconBase(_ref) {
	  var fill = _ref.fill;
	  var size = _ref.size;
	  var viewBox = _ref.viewBox;
	  var style = _ref.style;
	  var children = _ref.children;

	  var props = _objectWithoutProperties(_ref, ["fill", "size", "viewBox", "style", "children"]);

	  if (SizePresets.hasOwnProperty(size)) {
	    size = SizePresets[size];
	  }

	  return _react2.default.createElement(
	    "svg",
	    _extends({
	      fill: "currentColor",
	      preserveAspectRatio: "xMidYMid meet",
	      width: size,
	      height: size,
	      viewBox: viewBox
	    }, props, {
	      style: _extends({
	        verticalAlign: 'middle',
	        color: fill
	      }, style)
	    }),
	    children
	  );
	}

	IconBase.defaultProps = {
	  size: 'large'
	};

	IconBase.propTypes = {
	  className: _react2.default.PropTypes.string,
	  fill: _react2.default.PropTypes.string,
	  size: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	  children: _react2.default.PropTypes.node.isRequired,
	  viewBox: _react2.default.PropTypes.string.isRequired,
	  style: _react2.default.PropTypes.object
	};

	IconBase.displayName = 'IconBase';

	exports.default = IconBase;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = window.React;

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_vu-icon-base@2.0.2@@ali/vu-icon-base/build/index.js
// module id = 138
// module chunks = 0